module.exports = __webpack_public_path__ + "files/SPIADI2026 - OBSERVA4 - Fiche P1 (Version 1).fbc3dbb7eb402bac6d3fcb195001e855.pdf";